<div class="container">
    <div class="section-title">
        <h2>{{ "main_title_quests" | translate }}</h2>
        <div class="bar"></div>
        <p>{{ "sub_title_quests" | translate }}</p>
    </div>

    <!-- <div class="loop_quest" *ngFor="let item of [0, 1, 2, 3]">
        <div class="quest-type">
            <h3>
                Ẩm thực
                <a routerLink="/"
                    ><fa-icon
                        [icon]="faCircleChevronRight"
                        class="icon_navigation"
                    ></fa-icon
                ></a>
            </h3>
            <br />
        </div>

        <div class="row pb-50">
            <div class="col-lg-3 col-md-6" *ngFor="let item of [0, 1, 2, 3]">
                <div class="single-blog-post">
                    <div class="image">
                        <a routerLink="/single-blog"
                            ><img
                                src="assets/img/quest/vinpearl_safari_phu_quoc_gonatour.png"
                                alt="image"
                        /></a>
                    </div>

                    <div class="content">
                        <ul class="post-meta">
                            <li>
                                <fa-icon
                                    [icon]="faLocationDot"
                                    class="icon_location"
                                ></fa-icon>
                                Phú Quốc
                            </li>
                            <li>
                                <i class="fa fa-comments"></i>
                                <a routerLink="/single-blog">
                                    <fa-icon
                                        [icon]="faStar"
                                        class="icon_star"
                                    ></fa-icon>
                                    5.0 (41)
                                </a>
                            </li>
                        </ul>
                        <div class="block-ellipsis">
                            <h3>
                                <a routerLink="/single-blog"
                                    >Vinpearl Safari Phú Quốc</a
                                >
                            </h3>
                        </div>
                        <div class="d-flex">
                            <span class="pack_price">150.000 đ</span>
                            <span class="per_quest">/ Quest </span> &nbsp;
                            <span class="minutes"> · 150 phút</span>
                        </div>
                        <a routerLink="/single-blog" class="read-more"
                            >Xem chi tiết</a
                        >
                    </div>
                </div>
            </div>

            <div class="about-btn">
                <a routerLink="/blog" class="default-btn"
                    >{{ "btn_readmore" | translate }}<span></span
                ></a>
            </div>
        </div>
    </div> -->

    <!-- <div *ngFor="let item of questTypes">
        <div *ngIf="item.quests[0] != null">
            <h6>{{ item.name }}</h6>

            <div *ngFor="let item2 of quests">
                <div *ngIf="item2?.questTypeId == item.id">
                    {{ item2.title }}
                </div>
            </div>
            <hr />
        </div>
    </div> -->

    <div class="loop_quest" *ngFor="let questType of questTypes">
        <div class="quest-type">
            <h3>
                {{ questType.name }}
                <a (click)="goListQuests(questType.id)"
                    ><fa-icon
                        [icon]="faCircleChevronRight"
                        class="icon_navigation"
                    ></fa-icon
                ></a>
            </h3>
            <br />
        </div>

        <div class="row pb-50">
            <ng-container *ngFor="let quest of quests">
                <div
                    class="col-lg-3 col-md-6"
                    *ngIf="quest?.questTypeId == questType.id"
                >
                    <div class="single-blog-post">
                        <div (click)="goQuestDetails(quest.id, questType.id)">
                            <div class="image">
                                <a class="quest_img">
                                    <img
                                        class="quest_thumbnail"
                                        src="{{
                                            quest.imagePath == null
                                                ? 'http://via.placeholder.com/306x180'
                                                : quest.imagePath
                                        }} "
                                        alt="không có hình ảnh"
                                    />
                                </a>
                            </div>

                            <div class="content">
                                <ul class="post-meta">
                                    <li>
                                        <div *ngFor="let area of areas">
                                            <div *ngFor="let city of cities">
                                                <div
                                                    *ngIf="
                                                        quest.areaId ==
                                                            area.id &&
                                                        area.cityId == city.id
                                                    "
                                                >
                                                    <fa-icon
                                                        [icon]="faLocationDot"
                                                        class="icon_location"
                                                    ></fa-icon>
                                                    {{ city.name }}
                                                </div>
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <i class="fa fa-comments"></i>
                                        <a>
                                            <fa-icon
                                                [icon]="faStar"
                                                class="icon_star"
                                            ></fa-icon>


                                            <!-- New -->
                                            <span
                                                *ngIf="
                                                    quest.totalFeedback !=
                                                        null &&
                                                        quest.averageStar !=
                                                            null;
                                                    else feedbackNull
                                                "
                                            >
                                                {{ quest.averageStar }} ({{
                                                    quest.totalFeedback
                                                }})
                                            </span>
                                            <ng-template #feedbackNull>
                                                <span> 0 (0) </span>
                                            </ng-template>

                                            <!-- </span> -->
                                        </a>
                                    </li>
                                </ul>
                                <div class="block-ellipsis">
                                    <h3>
                                        <a>
                                            {{ quest.title }}
                                        </a>
                                    </h3>
                                </div>
                                <div class="d-flex">
                                    <span class="pack_price">
                                        {{ quest.price | number }} đ</span
                                    >
                                    <span class="per_quest">/ Quest </span>
                                    &nbsp;
                                    <span class="minutes">
                                        · {{ quest.estimatedTime }}
                                        {{ "minute" | translate }}
                                    </span>
                                </div>
                                <a class="read-more">{{
                                    "seeDetails" | translate
                                }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- <div *ngFor="let quest of quests">
                <div *ngIf="quest?.questTypeId == questType.id"> -->
                    <div class="about-btn" [ngStyle]="{'display': eventMatch(questType.quests) ==true ? 'block' : 'none' }">
                        <a
                            class="default-btn"
                            (click)="goListQuests(questType.id)"
                            >{{ "btn_readmore" | translate }}<span></span
                        ></a>
                    <!-- </div>
                </div> -->
            </div>
        </div>

        <!-- </div> -->
    </div>
</div>
